
  export default {
    props: {
      dayTitle: {
        type: String,
        default: '00'
      },
      itemTitle: {
        type: String,
        default: 'Title'
      },
      itemDesc: {
        type: String,
        default: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris molestie '
      }
    }
  }

